export enum DataFieldPropertyType {
    Name = 1,
    Description = 2,
    Cluster = 3,
    Areas = 4,
    BusinessAreas = 5,
    PhoneNumber = 6,
    EmailAddress = 7,
    Address = 8,
    Password = 9,
    Active = 10,
    Roles = 11,
    Tags = 12,
    Units = 13,
    Languages = 14,
    PKOrgNr = 15,
    Custom = 100,
}
